import React from "react";
import Link from "components/link";
import { trackNavClick } from "analytics";
import DropdownMenu from "./dropdown-menu";
import { useSettings } from "hooks/useStore";

const GroupLinks = ({ data, setShowOverlay, className, embedHeader }) => {
	const { toggleMenu } = useSettings(["toggleMenu"]);

	const handleLinkClick = (link) => {
		toggleMenu(false);
		if (link.url) {
			trackNavClick(link.title);
		}
	};

	return (
		<DropdownMenu data={data} setShowOverlay={setShowOverlay} className={className}
			childrenClass="group-links-container" embedHeader={embedHeader}>
			<div className="flex flex-col pr-10">
				{data.links?.map((link) => (
					link._type === "link" ? (
						<Link
							to={link.url}
							key={link?._key}
							onClick={() => handleLinkClick(link)}
							className="text-left py-2 flex items-center gap-4 hover:opacity-70 whitespace-nowrap"
							role="menuitem"
						>
							{link.title}
						</Link>
					) : null
				))}
			</div>
		</DropdownMenu>
	);
};

export default GroupLinks;